import React from "react";
import { GridItem, GridContainer } from "./AcquirerForm.styles";
import TextField from "../../textField/TextField";
import SelectField from "../../selectField/SelectField";
import SwitchField from "../../switchField/SwitchField";

const AcquirerInfo = ({
  formValues,
  handleChange,
  handleBlur,
  setFieldValue,
  errors,
  touched,
  currencies,
  modeForm,
}) => {
  const {
    acquirerName,
    email,
    withISO,
    acquirer: { city, state, county, address, postalCode, countryCode },
    fiat: { currencyCode },
  } = formValues;

  return (
    <GridContainer>
      <GridItem xs={12} md={6} lg={4} padding="0 15px 15px 0">
        <TextField
          id="acquirerName"
          name="acquirerName"
          fullWidth
          label="Acquirer Name"
          value={acquirerName}
          onChange={handleChange}
          onBlur={handleBlur}
          required
          error={errors.acquirerName}
          touched={touched.acquirerName}
        />
      </GridItem>
      {modeForm === "create" && (
        <GridItem xs={12} md={6} lg={4} padding="0 15px 15px 0">
          <TextField
            id="email"
            name="email"
            fullWidth
            label="Email"
            value={email}
            onChange={handleChange}
            onBlur={handleBlur}
            required
            maxLength={100}
            error={errors?.email}
            touched={touched?.email}
            helperText="Email"
          />
        </GridItem>
      )}
      {modeForm === "create" && (
        <GridItem xs={12} md={6} lg={4} padding="0 15px 15px 0">
          <SwitchField
            id="withISO"
            name="withISO"
            label="With ISO"
            value={withISO}
            onChange={(e) => setFieldValue("withISO", e.target.value)}
            onBlur={handleBlur}
            error={errors.withISO}
            touched={touched.withISO}
          />
        </GridItem>
      )}
      <GridItem xs={12} md={6} lg={4} padding="0 15px 15px 0">
        <TextField
          id="acquirer.city"
          name="acquirer.city"
          fullWidth
          label="City"
          value={city}
          onChange={handleChange}
          onBlur={handleBlur}
          required
          error={errors.acquirer?.city}
          touched={touched.acquirer?.city}
        />
      </GridItem>
      <GridItem xs={12} md={6} lg={4} padding="0 15px 15px 0">
        <TextField
          id="acquirer.state"
          name="acquirer.state"
          fullWidth
          label="State"
          value={state}
          onChange={handleChange}
          onBlur={handleBlur}
          required
          error={errors.acquirer?.state}
          touched={touched.acquirer?.state}
        />
      </GridItem>
      <GridItem xs={12} md={6} lg={4} padding="0 15px 15px 0">
        <TextField
          id="acquirer.county"
          name="acquirer.county"
          fullWidth
          label="County"
          value={county}
          onChange={handleChange}
          onBlur={handleBlur}
          error={errors.acquirer?.county}
          touched={touched.acquirer?.county}
        />
      </GridItem>
      <GridItem xs={12} md={6} lg={4} padding="0 15px 15px 0">
        <TextField
          id="acquirer.address"
          name="acquirer.address"
          fullWidth
          label="Address"
          value={address}
          onChange={handleChange}
          onBlur={handleBlur}
          required
          error={errors.acquirer?.address}
          touched={touched.acquirer?.address}
        />
      </GridItem>
      <GridItem xs={12} md={6} lg={4} padding="0 15px 15px 0">
        <TextField
          id="acquirer.postalCode"
          name="acquirer.postalCode"
          fullWidth
          label="Postal Code"
          value={postalCode}
          onChange={handleChange}
          onBlur={handleBlur}
          required
          error={errors.acquirer?.postalCode}
          touched={touched.acquirer?.postalCode}
        />
      </GridItem>
      <GridItem xs={12} md={6} lg={4} padding="0 15px 15px 0">
        <TextField
          id="acquirer.countryCode"
          name="acquirer.countryCode"
          fullWidth
          label="Country Code"
          value={countryCode}
          onChange={handleChange}
          onBlur={handleBlur}
          required
          error={errors.acquirer?.countryCode}
          touched={touched.acquirer?.countryCode}
        />
      </GridItem>
      <GridItem xs={12} md={6} lg={4} padding="0 15px 15px 0">
        <SelectField
          id="fiat.currencyCode"
          name="fiat.currencyCode"
          fullWidth
          label="Currency"
          value={currencyCode}
          options={currencies}
          required
          maxLength={5}
          onChange={handleChange}
          onBlur={handleBlur}
          error={errors.fiat?.currencyCode}
          touched={touched.fiat?.currencyCode}
        />
      </GridItem>
    </GridContainer>
  );
};

export default AcquirerInfo;
